import type { AccountApplicationState } from "./types";

const REVIEW_STATES: AccountApplicationState[] = [
  "reviewing",
  "docs_requested",
  "docs_in_review",
  "review",
  "review_reissued",
];

function isReviewState(state: AccountApplicationState): boolean {
  return REVIEW_STATES.includes(state);
}

export { isReviewState };
